/** @fileoverview Dashed placeholder for an attachment that is deleted or has no preview to show. */

export default function DeletedAttachment({ name, status }: { name: string; status: string }) {
  return (
    <li className="flex max-w-full min-w-0 justify-end">
      <span className="flex max-w-full min-w-0 items-center gap-2 rounded-lg border border-dashed border-app-border px-2.5 py-1.5 text-xs text-app-text-muted">
        <span className="truncate line-through" title={name}>
          {name}
        </span>
        <span className="shrink-0">({status})</span>
      </span>
    </li>
  );
}
